import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient} from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';



@Injectable({
  providedIn: 'root'
})


export class RaterFormService {

  updateAdminNotes(location_id: any, notes: string, who: string): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterform/updateAdminNotes/' + location_id, {notes: notes, who: who}, {observe: 'body'});
  }

  getTargetSet(location_id: any): Observable<any> {
    return this.http.get(this.baseURL + `/rhAPI/raterform/getTargetSet/${location_id}`, {observe: 'body'});
  }

  deletelastpicsFromFormTable(
     photoUrl: string,
     locpics_id: number,
     form_id: number,
     field_name: string):Observable<any>{
      console.log(locpics_id);
      return this.http.post(this.baseURL + '/rhAPI/raterpics/deleteLastPic/' 
      + form_id + '/' + locpics_id, 
      {image_url : photoUrl, field_name: field_name }, 
      {observe: 'body'});
  }
  
  saveHVACGrading(sysGradeObj, form_id: any):Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterform/saveHVACGrading/' + form_id, sysGradeObj, {observe: 'body'});
  }

  insertpicsToFormTable(id, obj):Observable<any>{
    return this.http.post(this.baseURL + `/rhAPI/raterpics/insertFormpics/${id}`, obj, {observe: 'body'});
  }

  deletepicsFromFormTable(photoUrl):Observable<any>{
    return this.http.post(this.baseURL + '/rhAPI/raterpics/deletePic', {image_url : photoUrl}, {observe: 'body'});
  }

  getFormPics(id: any, name: any):Observable<any>{
    return this.http.post( this.baseURL + '/rhAPI/raterpics/getFormpics/' + id + '/' + name, 
    {observe: 'body'});
  }

  getChecklistPicLocraterf(form_id: number, field: string): Observable<any> {
    return this.http.get(this.baseURL + `/rhAPI/raterpics/getpiclocraterf/${form_id}/${field}`, {observe: 'body'});
  }
  
  updateLocmainFormAndPics(location_id: any, locpicsObj: { form_id: any; locpics_id: any; }):  Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/updateLocmainFormAndPics/' + location_id, locpicsObj, {observe: 'body'});
  }
  
  getIDlocpicsByJobID(job_id: any): Observable <any> {
    return this.http.get(this.baseURL +  `/rhAPI/raterpics/getIDbyJobID/${job_id}`, {observe: 'body'});
  }

  getTagsForJob(job_id: any): Observable<any> {
    return this.http.get(this.baseURL +  `/rhAPI/jobEntry/getTagsRF/${job_id}`  , {observe: 'body'});
  }
  saveTags(job_id: any, inputTags: any[]): Observable<any> {
    return this.http.post(this.baseURL +  `/rhAPI/jobEntry/updateTagsRF/${job_id}` , {data: inputTags} , {observe: 'body'});
  }

  getThresholdData(location_id: any): Observable<any> { 
    return this.http.get(this.baseURL + '/rhAPI/raterform/getThresholds/' + location_id, {observe: 'body'});
  }

  getJobScope(job_id: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/customerjobs/getJobScope/' + job_id, {observe: 'body'});
  }
  isESMFNC(location_id: any) : Observable<any>{
    return this.http.get(this.baseURL +  `/rhAPI/raterform/isESMFNC/${location_id}`, {observe: 'body'});
  }

  getMultifamilyData(form_id: any): Observable<any> {
    return this.http.get(this.baseURL +  `/rhAPI/multifamily/getMfData/${form_id}`, {observe: 'body'});
  }

  sendMFdataEmail(data: any, location_id: any): Observable<any> {
    return this.http.post(this.baseURL +  `/rhAPI/multifamily/sendDataEmail/${location_id}` , {data: data} , {observe: 'body'});
  }

  resetBuilderLocation(location_id: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/locations/resetBuilderLocation/' + location_id, {}, {observe: 'body'});
  }

  blankPics(job_id: any): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterform/blankPics/' + job_id, {},{observe: 'body'});
  }


  rfloadBlankData(fid: any):Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/raterform/blankForm/' + fid, {},{observe: 'body'});
  }

  getMultifamilyTemplate(job_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/multifamily/getJobTemplate/' + job_id, {observe: 'body'});
  }

  sendMFemail(data: any, template: any, location: any): Observable<any> {

    //console.log(template);
    let obj = {
      data : data,
      template : template.fields,
      location : location
    }

    return this.http.post(this.baseURL + '/rhAPI/multifamily/sendEmail', obj , {observe: 'body'});
  }

  sendMfReportNGBS(data: any, template: any, location: any): Observable<any> {

    //console.log(template);
    let obj = {
      data : data,
      template : template.fields,
      location : location
    }

    return this.http.post( this.baseURL + '/rhAPI/multifamilyReportsNGBS', obj , {observe: 'body'});
  }




  getLastChanged(field: string, form_id: any): Observable<any> {
    //throw new Error('Method not implemented.');
    return this.http.get(this.baseURL + '/rhAPI/raterform/getlast/' + field + '/' + form_id);
  }


  private baseURL = environment.baseUrl;

  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent){}

  uploadImageChecklist(pic: File, name: string ): Observable<any> {
    const formData = new FormData();
    formData.append('file', pic);
    formData.append('name', name);


    formData.forEach((value, key) => {
    });

    return this.http.post(this.baseURL + '/rhAPI/uploadRaterPicNew', formData);
  }

  // Same upload as uploadImageChecklist, but streams progress events for a progress bar.
  uploadRaterPicWithProgress(pic: File, name: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', pic);
    formData.append('name', name);
    return this.http.post(this.baseURL + '/rhAPI/uploadRaterPicNew', formData, { reportProgress: true, observe: 'events' });
  }


  getPrefixLink(){
    return this.baseURL;
  }



  uploadImageElevPhoto(pic: File, name: string): Observable<any>{
    const formData = new FormData();
    formData.append('file', pic);
    formData.append('name', name);


    formData.forEach((value, key) => {
    });

    return this.http.post(this.baseURL + '/rhAPI/uploadElevPhoto', formData);

  }

  updateElevPhotoRecord(url: string, name: string): Observable<any>{
    return this.http.post(this.baseURL + url, {file: name});
  }


  updateSingleNote(locid, field, note): Observable<any> {

    let theObj = {
      note : note
    }
    return this.http.post(this.baseURL + '/rhAPI/updateSingleNote/' + locid + '/' + field, theObj, {observe:'body'} );
  }

  rfloadOldData(id): Observable<any> {

    return this.http.get(this.baseURL + '/rhAPI/raterformsId/' + id, {observe: 'body'});

  }


  getPlanData(location_id: number): Observable<any> {
    //this.messager.openSnackBar('Grabbing Plan Info...', '', 'basicAlert');
    return this.http.get(this.baseURL + '/rhAPI/plans/getAreas/' + location_id, {observe: 'body'}).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          //this.messager.openSnackBar('New Form created. ', 'Close', 'errorAlert');
        } else {
          //this.messager.openSnackBar('Success', '', 'successAlert');
        }
        })
      );
  }


/*
    $http.get('/rhAPI/customers/getCompliance/' + upd.customer).then(function(response){
    if(response.data.Compliance.codecomp) {
      $scope.model.codecomp = response.data.Compliance.codecomp || "Not specified";
    }
});
*/

/*
$http.get('/rhAPI/locations/edit/'+ upd.location_id).then(function(response){
  $scope.model.streetAddress = response.data.Location.street_address;
  $scope.address = response.data.Location.street_address;
  $scope.model.lot = response.data.Location.lot;
  $scope.model.subdivision = response.data.Location.subdivision_name;
  var subdivision_id = response.data.Location.subdivision;
  $http.get('/rhAPI/subdivisions/edit/' + subdivision_id).then(function(response){
    $scope.model.weatherloc = response.data.Subdivision.weatherloc;
    //$scope.model.elevation = response.data.Subdivision.elevation;
    $scope.model.city = response.data.Subdivision.city;

  $http.get('/rhAPI/city/getCityByName/' + $scope.model.city).then(function(response){
      $scope.model.elevation? $scope.model.elevation : response.data.City.elevation;
     // alertify.success('elevation from city: ' + response.data.City.elevation);
  });
    //alertify.success('City from subdivision: ' + response.data.Subdivision.city);
  });

})
*/

    multifamilypicUpload(jobid, fieldname): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/multifamily/updateMultifamilyPhoto/' + jobid + '/' + fieldname, {observe: 'body'});
    }


    getComplianceData(customerid: number): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/customers/getCompliance/' + customerid, {observe: 'body'});
    }

    getLocationData(location_id: number): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/locations/edit/' + location_id, {observe: 'body'});
    }

    getSubdivisionData(subdivision_id: number): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/subdivisions/edit' + subdivision_id, {observe: 'body'});
    }

    getCityData(cityid: number): Observable<any> {
      return this.http.get('/rhAPI/city/getCityByName/' + cityid, {observe: 'body'});
    }

    addEngineerLetterTag(location_id): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterform/addEngineerLetterTag/' + location_id, {}, {observe: 'body'});
    }

    removeEngineerLetterTag(location_id): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterform/removeEngineerLetterTag/' + location_id, {}, {observe: 'body'});
    }

    updateImageField(jobid, field, url): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterpics/upd/' + jobid + '/' + field, {file : url}, {observe:'body'});
    }

    updateImageFieldForm(id, field): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterpics/updFormField/' + id + '/' + field , {}, {observe:'body'});
    }
      
    getElevPhotos(locationid): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/getelevPics/' + locationid, {observe: 'body'});
    }

    insertNewForm(jobdata): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterformNew/', jobdata, {observe: 'body'});
    }

    updateRaterForm(formid, form): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterformUpdate/' + formid, form, {observe: 'body'});
    }

    getMultifamilyTemplates(name): Observable<any> {
      //console.log(name);
      return this.http.get<any>(this.baseURL + '/rhAPI/multifamily/getTemplatesByName/' + name);
    }

    updateMFdata(formid, id, data): Observable<any> {
      let obj = {
        data : data
      }
      return this.http.post(this.baseURL + '/rhAPI/multifamily/saveMultifamilyData/' + formid + '/' + id, obj, {observe: 'body'});
    }

    insertNewPics(pics, jobid):  Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterpics/add/' + jobid, pics, {observe: 'body'});
    }

    loadv3UploadsDriveFolderLink(location_id): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/raterform/getDriveLink/' + location_id, {observe: 'body'});
    }

    updateNotes(location_id, notesObj): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raternotes/update/' + location_id, notesObj, {observe: 'body'});
    }


    getRaterNotes(locationid): Observable<any>{
      return this.http.get(this.baseURL + '/rhAPI/raternotes/' + locationid, {observe: 'body'});
    }
    addExifData(body):Observable<any>{
      return this.http.post(this.baseURL + '/rhAPI/raterform/exifData',body)
    }


    updateSingleField(fieldname, id, value): Observable<any> {
      let obj = {
        value : value
      }
      return this.http.post(this.baseURL + '/rhAPI/raterformSingleUpdate/' + id + '/' + fieldname, obj, {observe: 'body'});
    }

    addRaterNotes(locationid): Observable<any>{
       return this.http.get(this.baseURL + '/rhAPI/raternotes/add/' + locationid, {observe: 'body'});
      }

    updateRFLog(fieldname, id, value, who): Observable<any> {

      let obj = {
        formid : id,
        rater : who,
        item : fieldname,
        thevalue : value
      }
      return this.http.post(this.baseURL + '/rhAPI/raterform/rhLog', obj, {observe:'body'});
    }


    updateFormID(fid, jobid): Observable<any> {
      var formObj = {
                    form_id : fid
                  };
      return this.http.post(this.baseURL + '/rhAPI/jobEntry/setForm/' + jobid, formObj, {observe: 'body'});
    }

    getRaternotePresets(): Observable<any>{
      return this.http.get(this.baseURL + '/rhAPI/raterform/getRaterformNotesPresets', {observe:'body'});
    }

    getSubdivisionByID(subid): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/subdivisions/edit/' + subid, {observe:'body'});
    }


    getESMFNCdesc():Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/raterform/getESMFNCdesc', {observe:'body'});
    }

    getESMFNCdata(location_id):Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/raterform/getESMFNCdata/' + location_id, {observe: 'body'} );
    }

    addESMFNCdata(location_id):Observable<any> {
      //form_id, job_id, location_id
      return this.http.post(this.baseURL + '/rhAPI/raterform/insertESMFNCdata/' + location_id, {}, {observe: 'body'});
    }

    updateESMFNCdataSF(id, fieldname, data):Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/raterform/updateESMFNCdataSF/' + id + '/' + fieldname, data, {observe: 'body'});
    }

    sendESMFNCdata(data):Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/multifamily/sendESMFNC', data, {observe: 'body'});
    }

    sendESMFNCReportEmail(data):Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/multifamilyReports', data, {observe: 'body'});
    }

    uploadDirectToS3(presignedUrl: string, file: File):Observable<any> {
      return this.http.put(presignedUrl, file, {
        headers: { "Content-Type": file.type || "application/octet-stream"},
        reportProgress: true, 
        observe: "events"
      });
    }

    getPresignedURL(key, contentType): Observable<{url: string}>{
      return this.http.post<{url: string}>(this.baseURL + "/rhAPI/photouploads/getPresignedURL", {key, contentType}, {observe: 'body'});
    }

    

}
